// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountUser } from './account-user';
import { ProgramUserGroup } from './program-user-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramUserGroupMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK programUserGroup */
  programUserGroupId!: string;
  /** Guid key FK accountUser */
  accountUserId!: string;
  /** DateTime */
  joinDate!: Date;
  /** FK accountUserId */
  accountUser!: AccountUser;
  /** FK programUserGroupId */
  programUserGroup!: ProgramUserGroup;
}

